import { takeEvery } from 'redux-saga/effects'

import { SET_NOTIFICATION_MESSAGE } from 'quick-quote/notification/actions'

/**
 * handleNotification
 * @param {ReturnType<import('history').createBrowserHistory>} history
 * @param action
 */
function handleNotification(history, action) {
  if (action.payload.type === 'INACTIVE_USER') {
    const encodedError = encodeURIComponent('lbCode terminated')
    history.push(`/authorize/error?error_description=${encodedError}`)
  }
}

/**
 * @param serviceWrapper {Awaited<ReturnType<import('core/service-wrapper/wrapper').buildServiceWrapper>>}
 * @param {ReturnType<import('history').createBrowserHistory>} history
 */
export function* sagas(serviceWrapper, history) {
  if (serviceWrapper.usePartnerApi) {
    yield [takeEvery(SET_NOTIFICATION_MESSAGE, handleNotification, history)]
  }
}
